module.exports = __webpack_public_path__ + "static/media/fishroe.7e006fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/fishroe.jpg
// module id = 128
// module chunks = 0